import { Inject, Injectable, isDevMode } from '@angular/core';
import { RxapAuthenticationService } from '@rxap/authentication';
import { KeycloakService } from 'eurogard-keycloak';
import { EurogardAuthenticationService } from './eurogard-authentication.service';
import { NavigationItem, NavigationStatus } from 'angular-components/navigation/navigation-item';
import { BackendStatusService } from './backend-status.service';
import { filter, firstValueFrom } from 'rxjs';

export interface EurogardNavigationItem extends NavigationItem {
  permissions?: string[];
}

@Injectable({providedIn: 'root'})
export class NavigationStatusService implements NavigationStatus {

  constructor(
    @Inject(KeycloakService)
    private readonly keycloakService: KeycloakService,
    @Inject(RxapAuthenticationService)
    private readonly authenticationService: EurogardAuthenticationService,
    private readonly backendStatusService: BackendStatusService,
  ) {
  }

  async isVisible(navigationItem: EurogardNavigationItem): Promise<boolean> {
    const status = await firstValueFrom(this.backendStatusService.status.pipe(filter(value => !!value)));
    if (navigationItem.backendStatusProperty && status[navigationItem.backendStatusProperty] === false) {
      return false;
    }

    const roles = this.keycloakService.getUserRoles();
    if (navigationItem.permissions?.length) {
      const hasPermission = navigationItem.permissions.some(permission => roles.includes(permission));
      if (isDevMode()) {
        console.warn('NavigationStatusService :: User does not have the required permissions');
      }
      return hasPermission;
    }

    return true;
  }


}
